module.exports = __webpack_public_path__ + "img/Pf.6ac233c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shot-images/Pf.jpg
// module id = iCeX
// module chunks = 1